import { getDirection } from "features/dashboard/utils/notification-utils"

interface BasicInfoCardProps {
  cameraId: string
  timestamp: string
  eventType: string
  metadata: Record<string, string>
}

const BasicInfoCard = ({ cameraId, timestamp, eventType, metadata }: BasicInfoCardProps) => (
  <div className='detail-card'>
    <h4>
      <i className='pi pi-info-circle mr-2' />
      Informações Básicas
    </h4>
    <div className='detail-grid'>
      <div className='detail-item'>
        <span className='detail-label'><i className='pi pi-video mr-1' />Câmera:</span>
        <span className='detail-value'>{cameraId}</span>
      </div>

      <div className='detail-item'>
        <span className='detail-label'><i className='pi pi-clock mr-1' />Data/Hora:</span>
        <span className='detail-value'>{new Date(timestamp).toLocaleString('pt-BR')}</span>
      </div>

      <div className='detail-item'>
        <span className='detail-label'><i className='pi pi-tag mr-1' />Tipo de Evento:</span>
        <span className='detail-value'>
          {eventType === 'AHCRDetection'
            ? 'Detecção de Pessoa'
            : eventType === 'ANPRDetection'
              ? 'Detecção de Veículo'
              : eventType || 'Detecção de Veículo'}
        </span>
      </div>

      {metadata.Direction && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-compass mr-1' />Direção:</span>
          <span className='detail-value'>{getDirection(metadata.Direction)}</span>
        </div>
      )}

      {metadata.Location && (
        <div className='detail-item'>
          <span className='detail-label'><i className='pi pi-map-marker mr-1' />Local:</span>
          <span className='detail-value'>{metadata.Location}</span>
        </div>
      )}
    </div>
  </div>
)

export default BasicInfoCard
